import bootstrap from 'bootstrap/dist/js/bootstrap';
window.bootstrap = bootstrap;
